import { Injectable } from '@angular/core';
import { ModalOptions } from '@app/core/model/modalOptions';
import { DomService } from '@app/core/ui/modal/dom.service';
import { Subject } from 'rxjs';

@Injectable()
export class ModalService {
  private modalElementId = 'modal-container';
  public onValidate: Subject<any>;
  public onCancel: Subject<any>;
  public modalOptions: ModalOptions;

  constructor(private domService: DomService) {}

  /**
   * Init our modal host component
   * @param modalOptions Modal options
   */
  init(modalOptions: ModalOptions) {
    this.modalOptions = modalOptions;
    this.onValidate = new Subject();
    this.onCancel = new Subject();

    /**
     * Create modal host component
     */
    this.domService.appendComponentTo(
      this.modalElementId,
      modalOptions.modalComponent
    );
    document.getElementById(this.modalElementId).classList.add('active');
  }

  /**
   * Remove component from DOM
   */
  destroy(): void {
    this.domService.removeComponent();
    document.getElementById(this.modalElementId).classList.remove('active');
  }

  /**
   * Event triggered when the modal is canceled
   */
  cancel(): void {
    this.destroy();
    this.onCancel.next({});
  }

  /**
   * Event triggered when the modal is validated
   * The modal component is destroyed (removed from DOM)
   * And then we push data in our BehaviorObject to be able to observe him and catch modal data when the modal is closed
   * @param data any
   */
  validate(data?: any): void {
    this.destroy();
    this.onValidate.next(data);
  }
}
